import React from 'react';
import { useSelector } from 'store';
import type { ChatSidebarUnreadCountKey } from 'utils/chat-sidebar-unread-view';

const useUnreadCount = (viewId: ChatSidebarUnreadCountKey | undefined): number => {
  const unreadCounts = useSelector((state) => state.unreadChatUsers);

  const count = React.useMemo(() => {
    switch (viewId) {
      case 'chats':
        return unreadCounts.allUnreadCount;
      case 'my-chats':
        return unreadCounts.myUnreadCount;
      case 'not-my-chats':
        return unreadCounts.notMyUnreadCount;
      case 'unassigned-chats':
        return unreadCounts.noAssigneeUnreadCount;
      case 'bots-chats':
        return unreadCounts.botActiveUnreadCount;
      default:
        return 0;
    }
  }, [unreadCounts, viewId]);

  return count;
};

export default useUnreadCount;
